import {AxiosError} from 'axios';
import {GET_INTENDED_RESIDENTIAL_ZONE_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_INTENDED_RESIDENTIAL_ZONE_URL} from '../../constants/apiUrls';
import {LookupListApiItem} from '../../api/user/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: LookupListApiItem[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetIntendedResidentialZone = ({
                                                onSuccess,
                                                onError,
                                                enabled = true,
                                              }: Input = {}) => {
  const getIntendedResidentialZone = async () => {
    const res = await axiosClient.get<LookupListApiItem[]>(GET_INTENDED_RESIDENTIAL_ZONE_URL);
    return res.data;
  };

  return useCustomQuery(GET_INTENDED_RESIDENTIAL_ZONE_QUERY_KEY, getIntendedResidentialZone, {
    onSuccess,
    onError,
    enabled,
    staleTime: Infinity,
  });
};
